<div mat-dialog-title>
  We’re Sorry
  <div class="close-icon-container" (click)="onNoClick()">
    <fa-icon [icon]="['far', 'xmark']" class="gray"></fa-icon>
  </div>
</div>
<mat-divider></mat-divider>

<div mat-dialog-content>
  <p class="line-1">Your selected parcel is not eligible for our program.</p>
  <p class="line-2">Would you like us to contact you with more information?</p>
  <form [formGroup]="ineligibleParcelForm" class="fields">
    <mat-form-field class="w-100-1">
      <mat-label>Email</mat-label>
      <input matInput id="email" formControlName="email" required />
    </mat-form-field>
    <fc-email-form-errors [emailFormControl]="ineligibleParcelForm.controls.email"></fc-email-form-errors>
    <input class="hidden-check" tabindex="-1" formControlName="hiddenCheck" autocomplete="current-password" />
  </form>
</div>
<div mat-dialog-actions>
  <button (click)="onNoClick()" color="primary" data-cy="button-no" mat-stroked-button>No, Thank You</button>
  <button
    [disabled]="!ineligibleParcelForm.valid"
    [mat-dialog-close]="ineligibleParcelForm.value"
    color="primary"
    data-cy="button-yes"
    mat-raised-button>
    Yes, Contact Me
  </button>
</div>
